import { ColDef } from 'ag-grid-community';

import { ConnectorUser } from './types';

export const EMAIL_COLUMN_MIN_WIDTH = 250;

export const FIELD_PRIORITIES = ['email', 'username', 'id', 'name', 'enabled'];

export function columnSorter(columns: ColDef<ConnectorUser>[]) {
	columns.sort((a, b) => getSortValue(b) - getSortValue(a));

	if (!columns.length) return [];

	columns[0].sort = 'asc';

	columns[0].minWidth = EMAIL_COLUMN_MIN_WIDTH;

	return columns;

	function getSortValue(column: ColDef<ConnectorUser>) {
		const field = column?.field?.toLowerCase();

		if (!field) return 0;

		for (let i = 0; i < FIELD_PRIORITIES.length; i++) {
			const prio = (FIELD_PRIORITIES.length - i) * 2;

			if (field === FIELD_PRIORITIES[i]) return prio;

			if (field.endsWith(FIELD_PRIORITIES[i])) return prio - 1;
		}

		return 0;
	}
}
